export default (userToken) => ({ Authorization: `Bearer ${userToken}` });
